var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ion-toolbar',{attrs:{"color":"danger"}},[(_vm.error)?_c('div',[_vm._v(_vm._s(_vm.error))]):_vm._e(),_c('div',{staticClass:"ion-text-center h-f-m"},[_vm._v("You have "+_vm._s(_vm.shiftCount)+" shifts this month!")])])}
var staticRenderFns = []

export { render, staticRenderFns }